import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Menu } from '@material-ui/core';
import { LinkOff as LinkOffIcon } from '@material-ui/icons';
import {
    FHEReactSelect,
    FHEItemText,
    FormEditButton,
    FHEButton,
    FHEBoxAutoComplete,
    BtnPrintEtiquette,
    FormButtonContainer,
    FHEDivider,
} from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { Map } from 'immutable';
import ActionsMenu from '../components/ActionsMenu';
import { updateBoxDetails, associateBox, dissociateBox, disableZway, enableZway, changeUpgradeStatus, boxSwap } from '../../../data/Boxes/actions';
import getSelectors from '../selectors';
import ConfigOverride from '../components/ConfigOverride';
import FileManager from '../../../components/FileManager';

class FormBox extends Component {
    static propTypes = {
        boxesArray: PropTypes.array.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        boxSwap: PropTypes.func.isRequired,
        enableZway: PropTypes.func.isRequired,
        disableZway: PropTypes.func.isRequired,
        associateBox: PropTypes.func.isRequired,
        dissociateBox: PropTypes.func.isRequired,
        updateBoxDetails: PropTypes.func.isRequired,
        changeUpgradeStatus: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        brands: PropTypes.object.isRequired,
        homeBox: PropTypes.object.isRequired,
        prefixCenter: PropTypes.string.isRequired,
        homeLabel: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        homeId: PropTypes.number.isRequired,
        codeEnv: PropTypes.number.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            provisionningBox: false,
            formDisabled: true,
            boxForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false,
            btnLoading: false,
            openedMenu: false,
            anchorEl: null,
            boxSwapping: false,
        };
    }

    getDataForm = () => {
        const { homeBox, brands } = this.props;
        const brand = brands.filter(brand => brand.get('key') === homeBox.get('brand'));
        return {
            brand: brand.size !== 0 ? homeBox.get('brand') : null,
        };
    };

    getBrandsList = memoizeOne(brands => {
        return brands.reduce((acc, brand) => [...acc, { value: brand.get('key'), label: brand.get('title') }], []);
    });
    loadInputs = () => {
        this.setState({
            formDisabled: true,
            provisionningBox: false,
            sendLoading: false,
            boxForm: this.getDataForm(),
            boxMac: null,
            textInput_error: {},
        });
    };

    openMenuState = e => {
        this.setState({ openedMenu: true, anchorEl: e.currentTarget });
    };
    closeMenuState = () => {
        this.setState({ openedMenu: false });
    };
    handleBtnLoading = bool => {
        this.setState({ btnLoading: bool });
    };

    toggleProvisionningBox = () => {
        const { provisionningBox } = this.state;
        return this.setState({ provisionningBox: !provisionningBox });
    };
    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };
    formatForm = () => {
        const { boxForm } = this.state;

        let form = boxForm;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
        });
        this.setState({
            boxForm: form,
        });
    };
    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>,
                );
            });
        });

        this.setState({
            textInput_error: res,
        });

        return Toastr.error(message);
    };
    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v })),
        );
    };
    handleChangeBoxAutoComplete = (field, value) => {
        value = value.replace(/:/g, '');
        this.setState({
            boxMac: value,
        });
    };
    handleChange = event => {
        const { boxForm, textInput_error } = this.state;
        let targetValue = event.target.value;
        let newTextInput_error = this.removeKey(textInput_error, event.target.name);
        this.setState({
            boxForm: { ...boxForm, [event.target.name]: targetValue },
            textInput_error: newTextInput_error,
        });
    };
    validateForm = form => {
        const errors = {};

        if (this.isEmpty(form.brand)) {
            errors['brand'] = Translator.translate('general.fields.error.any.empty');
        }

        this.setState({
            textInput_error: errors,
        });

        return Object.keys(errors).length <= 0;
    };

    confirmEdit = () => {
        const { boxForm } = this.state;
        const { updateBoxDetails, homeBox, homeLabel } = this.props;

        this.formatForm();

        if (this.validateForm(boxForm)) {
            this.setState({
                sendLoading: true,
            });
            return updateBoxDetails(homeBox.get('macAddress'), boxForm)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.home.actions.editHomeSuccess`, homeLabel));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                    });
                    Toastr.error(Translator.translateWithFallback(`api.message.${error.message}`, `generic.home.actions.editHomeError`, homeLabel));
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate(`generic.home.actions.editHomeError`, homeLabel));
                    }
                });
        }
    };
    handleEdit = () => {
        const { formDisabled } = this.state;
        if (formDisabled)
            this.setState({
                formDisabled: false,
            });
        else this.loadInputs();
    };

    enableZway = () => {
        const { homeBox, enableZway } = this.props;
        return enableZway(homeBox.get('macAddress'))
            .then(() => {
                Toastr.success(Translator.translate('generic.home.enableZway.success'));
            })
            .catch(error => {
                Toastr.error(Translator.translateWithFallback(`socket.error.${error.message}`, 'generic.home.enableZway.error'));
            });
    };

    disableZway = () => {
        const { homeBox, disableZway } = this.props;
        return disableZway(homeBox.get('macAddress'))
            .then(() => {
                Toastr.success(Translator.translate('generic.home.disableZway.success'));
            })
            .catch(error => {
                Toastr.error(Translator.translateWithFallback(`socket.error.${error.message}`, 'generic.home.disableZway.error'));
            });
    };

    dissociateBox = () => {
        const { homeBox, dissociateBox, match, history } = this.props;
        return Toastr.confirm(
            Translator.translate(
                `generic.home.dissociate.confirmDissociateBox`,
                Translator.translate(`${history.environment}.centerName`),
                homeBox
                    .get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
            ),
            Translator.translate(`generic.home.dissociate.confirmDissociateBoxTitle`, Translator.translate(`${history.environment}.centerName`)),
            {
                onYes: () => {
                    dissociateBox(homeBox.get('macAddress'), match.params.homeId).catch(error => {
                        Toastr.error(
                            Translator.translateWithFallback(
                                `api.message.${error.message}`,
                                `generic.home.actions.dissociateBoxError`,
                                homeBox
                                    .get('macAddress')
                                    .match(/.{1,2}/g)
                                    .join(':'),
                            ),
                        );
                    });
                },
            },
        );
    };
    associateBox = () => {
        const { boxMac } = this.state;
        const { associateBox, match, history } = this.props;
        this.setState({ sendLoading: true });
        associateBox(boxMac, match.params.homeId)
            .then(() => {
                this.setState({ boxMac: null, sendLoading: false });
            })
            .catch(error => {
                Toastr.error(
                    Translator.translateWithFallback(
                        `api.message.${error.message}`,
                        `generic.home.actions.associateBoxError`,
                        Translator.translate(`${history.environment}.centerName`),
                        boxMac,
                    ),
                );
                this.setState({ sendLoading: false });
            });
    };

    handleBoxSwap = () => {
        const { boxSwapping } = this.state;
        const { prefixCenter } = this.props;
        this.setState({
            boxSwapping: !boxSwapping,
            boxMac: prefixCenter,
        });
    };

    _renderBoxActions() {
        const { btnLoading, openedMenu, anchorEl, textInput_error, boxMac, provisionningBox, sendLoading } = this.state;
        const { classes, homeBox, boxesArray, profile, prefixCenter, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        const rightsAction = [
            `updateBox_${history.environment}`,
            `refreshBox_${history.environment}`,
            `restartBox_${history.environment}`,
            'startVpn',
            'stopVpn',
        ];
        if (homeBox.size > 0 && (profile.get('admin') || userRights.some(v => rightsAction.includes(v)))) {
            return (
                <Grid container spacing={3} justify="center" alignItems="center">
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEButton
                            fullWidth
                            className={classes.button}
                            content={Translator.translate(
                                `generic.home.button.menuActionsBox`,
                                Translator.translate(`${history.environment}.centerName`),
                            )}
                            clickFunction={this.openMenuState}
                            loading={btnLoading}
                        />
                        <Menu anchorEl={anchorEl} keepMounted open={openedMenu} onClose={this.closeMenuState} onClick={this.closeMenuState}>
                            <div>
                                <ActionsMenu
                                    boxMac={homeBox.get('macAddress')}
                                    boxId={homeBox.get('boxId')}
                                    homeId={homeBox.get('homeId')}
                                    handleLoading={this.handleBtnLoading}
                                    boxSwapAction={this.handleBoxSwap}
                                />
                            </div>
                        </Menu>
                    </Grid>
                </Grid>
            );
        } else if (!profile.get('admin') && !userRights.includes(`boxProvisionning_${history.environment}`)) {
            return (
                <div>
                    {Translator.translate(
                        `generic.center.table.body.emptyDataSourceMessage`,
                        Translator.translate(`${history.environment}.centerName`),
                    )}
                </div>
            );
        }

        if (!provisionningBox) {
            return (
                <Grid container spacing={3} justify="center" alignItems="center">
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEButton
                            content={Translator.translate(
                                `generic.home.button.provisionningBox`,
                                Translator.translate(`${history.environment}.centerName`),
                            )}
                            clickFunction={this.toggleProvisionningBox}
                            loading={provisionningBox}
                            disabled={provisionningBox}
                        />
                    </Grid>
                </Grid>
            );
        }

        return (
            <Grid container spacing={3} justify="center" alignItems="center">
                <Grid container item sm={12} md={6} lg={4} className={classes.containerAutoMac}>
                    <FHEBoxAutoComplete
                        id="boxMac"
                        baseValue={boxMac === null || !boxMac ? prefixCenter : boxMac}
                        error={textInput_error.boxMac}
                        label={Translator.translate('general.table.column.macAddress')}
                        name="boxMac"
                        data={boxesArray}
                        selectData={this.handleChangeBoxAutoComplete}
                    />

                    <FormEditButton
                        positionClassName={classes.saveButtonPosition}
                        formDisabled={!provisionningBox}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.associateBox}
                        sendLoading={sendLoading}
                    />
                </Grid>
            </Grid>
        );
    }

    getSelectedBrand = memoizeOne(brand => {
        const { brands } = this.props;
        const result = brands.find(x => x.get('key') === brand, null, new Map());
        return { value: result.get('key'), label: result.get('title') };
    });

    handleReactSelect = (event, options) => {
        const { boxForm, textInput_error } = this.state;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        this.setState({
            boxForm: { ...boxForm, [options.name]: event.value },
            textInput_error: newTextInput_error,
        });
    };

    changeUpgradeStatus = () => {
        const { changeUpgradeStatus, homeBox, history } = this.props;
        const action = homeBox.get('upgrade') === 1 ? 'disable' : 'enable';
        return changeUpgradeStatus(homeBox.get('macAddress'), action)
            .then(() => {
                Toastr.success(Translator.translate(`generic.home.upgrade.success`, Translator.translate(`${history.environment}.centerName`)));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translate(
                        `generic.home.upgrade.error`,
                        Translator.translate(`${history.environment}.centerName`),
                        err.message,
                        err.code ? err.code : '',
                    ),
                );
            });
    };

    _renderBoxDetail() {
        const { formDisabled, boxForm, textInput_error } = this.state;
        const { classes, homeBox, profile, brands, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        const zwaveRefreshStatus = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`zwaveRefreshStatus`);
        const userRightChangeUpgradeStatus = profile.get('admin') || userRights.includes(`changeUpgradeStatus_${history.environment}`);
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.macAddress')}
                        itemContent={
                            homeBox.get('macAddress') &&
                            homeBox
                                .get('macAddress')
                                .match(/.{1,2}/g)
                                .join(':')
                        }
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.firmwareVersion')}
                        itemContent={homeBox.get('firmwareVersion')}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.provisionedDate')}
                        itemContent={homeBox.get('provisionedDate')}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.boxState')}
                        itemContent={Translator.translate(`general.${homeBox.get('boxState')}`)}
                        iconButton={
                            profile.get('admin') ||
                            profile.getIn(['user_rights', history.environment], []).includes(`boxDissociate_${history.environment}`) ? (
                                <LinkOffIcon onClick={this.dissociateBox} />
                            ) : null
                        }
                        iconButtonTooltip={Translator.translate(
                            `generic.home.dissociate.tooltip`,
                            Translator.translate(`${history.environment}.centerName`),
                        )}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.status')}
                        itemContent={
                            homeBox.get('boxIsConnected') === undefined || homeBox.get('boxIsConnected') === null
                                ? ''
                                : homeBox.get('boxIsConnected')
                                ? Translator.translate('general.connected')
                                : Translator.translate('general.disconnected')
                        }
                        classContent={!homeBox.get('boxIsConnected') ? classes.disconnectedColor : classes.connectedColor}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.timeLag')}
                        itemContent={`${homeBox.get('timeDiff')} ${Translator.translate('general.seconds')}`}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.lastConnection')}
                        itemContent={homeBox.get('lastConnection')}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.freeSpace')}
                        itemContent={!homeBox.get('freeSpace') || homeBox.get('freeSpace') === null ? '' : `${homeBox.get('freeSpace')}%`}
                        classContent={
                            homeBox.get('freeSpace') > 80
                                ? classes.disconnectedColor
                                : homeBox.get('freeSpace') > 40
                                ? classes.warningColor
                                : classes.connectedColor
                        }
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.privateIp')}
                        itemContent={!homeBox.get('privateIp') ? '' : homeBox.get('privateIp')}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        tooltip={
                            homeBox.get('zwaveStatus') === 'disabled'
                                ? Translator.translate(`generic.home.enableZway.action`)
                                : Translator.translate(`generic.home.disableZway.action`)
                        }
                        onClick={zwaveRefreshStatus ? (homeBox.get('zwaveStatus') === 'disabled' ? this.enableZway : this.disableZway) : null}
                        itemTitle={Translator.translate('general.table.column.zwaveStatus')}
                        itemContent={
                            Translator.isTranslationExist(`general.zwave.${homeBox.getIn(['zwaveStatus'], 'noStatus')}`)
                                ? Translator.translate(`general.zwave.${homeBox.getIn(['zwaveStatus'], 'noStatus')}`)
                                : Translator.translate('general.zwave.other', homeBox.get('zwaveStatus'))
                        }
                        classContent={
                            homeBox.get('zwaveStatus') === 'disabled'
                                ? classes.disabledColor
                                : homeBox.get('zwaveStatus') === 'active'
                                ? classes.connectedColor
                                : classes.disconnectedColor
                        }
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEReactSelect
                        name="brand"
                        label={Translator.translate('general.table.column.brand')}
                        onChange={this.handleReactSelect}
                        value={this.getSelectedBrand(boxForm.brand)}
                        choices={this.getBrandsList(brands)}
                        error={textInput_error.brand}
                        disabled={formDisabled}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        tooltip={Translator.translate(`generic.home.upgrade.tooltip`)}
                        onClick={userRightChangeUpgradeStatus && Number.isInteger(homeBox.get('upgrade')) ? this.changeUpgradeStatus : null}
                        itemTitle={Translator.translate('general.table.column.upgrade')}
                        itemContent={
                            Number.isInteger(homeBox.get('upgrade')) ? Translator.translate(`general.data.mode.${homeBox.get('upgrade')}`) : null
                        }
                        classContent={homeBox.get('upgrade') === 0 ? classes.disconnectedColor : undefined}
                    />
                </Grid>
            </Grid>
        );
    }

    // renders

    renderButtonsForm() {
        const { formDisabled, sendLoading } = this.state;
        const { profile, homeBox, history, codeEnv } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        if (homeBox.size > 0) {
            const btns = [];

            if (profile.get('admin') || userRights.includes(`boxDetailsUpdate_${history.environment}`))
                btns.push(
                    <FormEditButton
                        key="edit"
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                        positionClassName="none"
                    />,
                );

            if (profile.get('admin') || profile.getIn(['user_rights', 'testbench'], []).includes(`boxes_${history.environment}`))
                btns.push(
                    <BtnPrintEtiquette
                        key="print"
                        boxId={homeBox.get('boxId')}
                        codeEnv={codeEnv}
                        codePack={homeBox.get('codePack')}
                        envBox={history.environment}
                        boxMac={homeBox.get('macAddress')}
                    />,
                );

            if (btns.length > 0) return <FormButtonContainer sendLoading={sendLoading} buttons={btns} />;
        }
    }

    confirmBoxSwap = () => {
        const { homeBox, boxSwap, boxesArray, history } = this.props;
        const { boxMac } = this.state;

        const newBox = boxesArray.find(x => x.mac === boxMac);
        const newBoxId = newBox ? newBox.id : null;

        boxSwap({ boxId: homeBox.get('boxId'), mac: homeBox.get('macAddress'), newBoxId, newMac: boxMac, homeId: homeBox.get('homeId') })
            .then(() => {
                this.setState({ boxSwapping: false });
                Toastr.success(Translator.translate(`generic.home.boxSwap.success`, Translator.translate(`${history.environment}.centerName`)));
            })
            .catch(err => {
                this.setState({ boxSwapping: false });
                Toastr.error(
                    Translator.translate(
                        `generic.home.boxSwap.error`,
                        Translator.translate(`${history.environment}.centerName`),
                        err.message,
                        err.code ? err.code : '',
                    ),
                );
            });
    };

    renderBoxSwapping = () => {
        const { textInput_error, boxMac, sendLoading } = this.state;
        const { classes, boxesArray, prefixCenter } = this.props;
        return (
            <Grid container spacing={3} justify="center" alignItems="center">
                <Grid container item sm={12} md={6} lg={4} className={classes.containerAutoMac}>
                    <FHEBoxAutoComplete
                        id="boxMac"
                        baseValue={boxMac === null || !boxMac ? prefixCenter : boxMac}
                        error={textInput_error.boxMac}
                        label={Translator.translate('general.table.column.macAddress')}
                        name="boxMac"
                        data={boxesArray}
                        selectData={this.handleChangeBoxAutoComplete}
                    />

                    <FormEditButton
                        positionClassName={classes.saveButtonPosition}
                        formDisabled={false}
                        handleEdit={this.handleBoxSwap}
                        confirmEdit={this.confirmBoxSwap}
                        sendLoading={sendLoading}
                    />
                </Grid>
            </Grid>
        );
    };

    render() {
        const { homeBox, profile, history, homeId } = this.props;
        const { boxSwapping, formDisabled } = this.state;
        const configOverrideRights = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('configOverride');
        const fileManagerRights = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeFilesActions');
        return boxSwapping ? (
            this.renderBoxSwapping()
        ) : (
            <Fragment>
                {this.renderButtonsForm()}
                {homeBox.size > 0 && this._renderBoxDetail()}
                {this._renderBoxActions()}

                <FileManager hasRights={fileManagerRights} type="homes" id={String(homeId)} formDisabled={formDisabled} />

                {homeBox.size > 0 && configOverrideRights && (
                    <Fragment>
                        <FHEDivider title={Translator.translate('general.table.column.configOverride')} />
                        <ConfigOverride />
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);
    const profile = selectors.getProfile(state);
    return {
        homeLabel: selectors.getHomeByHomeId(state, homeId).getIn(['label'], ''),
        homeId: parseInt(homeId),
        profile,
        brands: selectors.getBrands(state),
        prefixCenter: selectors.getPrefixCenter(state),
        boxesArray: selectors.getBoxesArray(state),
        homeBox: selectors.getBoxByHomeId(state, homeId),
        codeEnv: selectors.getCodeEnv(state),
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20,
    },
    title: {
        color: theme.palette.primary.main,
    },
    checkIcon: {
        color: theme.palette.success.main,
    },
    connectedColor: {
        color: theme.palette.success.main,
    },
    disconnectedColor: {
        color: theme.palette.error.main,
    },
    warningColor: {
        color: theme.palette.warning.main,
    },
    button: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    containerAutoMac: {
        position: 'relative',
    },
    saveButtonPosition: {
        position: 'absolute',
        top: 20,
        right: -80,
    },
});

export default withRouter(
    renderEnvComponent(
        'scenes/Home/forms/FormBox',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        associateBox,
                        dissociateBox,
                        updateBoxDetails,
                        enableZway,
                        disableZway,
                        changeUpgradeStatus,
                        boxSwap,
                    }),
                    dispatch,
                ),
        )(withStyles(styles, { withTheme: true })(FormBox)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/forms/FormBox.js